/**
 * This module defines a configuration for user menu items used within the application.
 * Each item includes an identifier, a title for display, an icon component for visual representation,
 * an optional dialog component that is triggered by interacting with the action item.
 */
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import CreateNewFolderRoundedIcon from '@mui/icons-material/CreateNewFolderRounded';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import AddPortfolioDialog from '../forms/AddPortfolioDialog';
import InviteManagerDialog from '../forms/InviteManagerDialog';

/**
 * A collection of string constants representing possible user actions.
 * The values of these constants correspond to the External Activity types set up in Pardot.
 * @constant
 * @type {Object}
 * @property {string} ADD_PORTFOLIO - Indicates the action of adding a portfolio.
 * @property {string} INVITE_MANAGER - Indicates the action of inviting a manager.
 */
export const UserActionType = {
    ADD_PORTFOLIO: 'ADD_PORTFOLIO',
    INVITE_MANAGER: 'INVITE_MANAGER',
    GO_PRO: 'GO_PRO'
};

export const homeMenuItemConfig = {
    id: 'HOME',
    title: 'Home',
    IconComponent: { outline: HomeOutlinedIcon, filled: HomeRoundedIcon },
    dataAnalyticsId: 'home'
};

export const addPortfolioMenuItemConfig = {
    id: UserActionType.ADD_PORTFOLIO,
    title: 'Add a Portfolio',
    IconComponent: {
        outline: CreateNewFolderOutlinedIcon,
        filled: CreateNewFolderRoundedIcon
    },
    DialogComponent: AddPortfolioDialog,
    dataAnalyticsId: 'add-portfolio'
};

export const inviteManagerMenuItemConfig = {
    id: UserActionType.INVITE_MANAGER,
    title: 'Invite a Manager',
    IconComponent: { outline: HandshakeOutlinedIcon, filled: HandshakeIcon },
    DialogComponent: InviteManagerDialog,
    dataAnalyticsId: 'invite-manager'
};

export const learnMoreMenuItemConfig = {
    id: 'LEARN_MORE',
    title: 'Learn More',
    IconComponent: { outline: HelpOutlineRoundedIcon, filled: HelpRoundedIcon },
    DialogComponent: InviteManagerDialog,
    dataAnalyticsId: 'learn-more'
};

/* Array of user action menu items used within the app for various menus */
export const userActionItems = [
    addPortfolioMenuItemConfig,
    inviteManagerMenuItemConfig
];
